module.exports = __webpack_public_path__ + "static/media/manfredWeiss.20e71d04.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/manfredWeiss.jpg
// module id = 1683
// module chunks = 1